import React from 'react'

import { CVQuality } from '../../../api/cv-roaster/types'
import { useI18N } from '../../../libraries/i18n/hook'
import QualityChip from '../cv-roaster/CVQualityChip'

type Props = { cvQuality: CVQuality}
const MatchLevelCV: React.FC<Props> = ({ cvQuality }) => {
  const { t } = useI18N()
  return <div><strong>{t('jobs.match.level.cv')}</strong> <QualityChip level={cvQuality} size='sm' /></div>
}

export default MatchLevelCV
